function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
  id: "path-1",
  points: "0 0 20 0 30 10 30 40 0 40"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "system"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-7"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-6"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-4"
}, /*#__PURE__*/React.createElement("g", {
  id: "Mask",
  fill: "#EFF4F6",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("polygon", {
  id: "path-1",
  points: "0 0 20 0 30 10 30 40 0 40"
})), /*#__PURE__*/React.createElement("g", {
  id: "fold-Clipped"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
  id: "mask-2",
  fill: "white"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path-1"
})), /*#__PURE__*/React.createElement("g", {
  id: "path-1"
}), /*#__PURE__*/React.createElement("rect", {
  id: "path-3",
  fill: "#D5E1E5",
  fillRule: "nonzero",
  mask: "url(#mask-2)",
  x: 20,
  y: 0,
  width: 10,
  height: 10
})))))), /*#__PURE__*/React.createElement("g", {
  id: "settings-gear-63",
  transform: "translate(6.250000, 13.750000)",
  fill: "#637282",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "M17.5,10.3409091 L17.5,7.15909094 L14.9052272,7.15909094 C14.7548864,6.57681819 14.5257954,6.02795454 14.2275,5.52204546 L16.0618182,3.68772727 L13.8122727,1.43818182 L11.9779546,3.2725 C11.4720454,2.97420454 10.9231818,2.74511364 10.3409091,2.59477273 L10.3409091,0 L7.15909094,0 L7.15909094,2.59477273 C6.57681819,2.74511364 6.02795454,2.97420454 5.52204546,3.2725 L3.68772727,1.43818182 L1.43818182,3.68772727 L3.2725,5.52204546 C2.97420454,6.02795454 2.74511364,6.57681819 2.59477273,7.15909094 L0,7.15909094 L0,10.3409091 L2.59477273,10.3409091 C2.74511364,10.9231818 2.97420454,11.4720454 3.2725,11.9779546 L1.43818182,13.8122727 L3.68772727,16.0618182 L5.52204546,14.2275 C6.02715909,14.5257954 6.57681819,14.7548864 7.15909094,14.9052272 L7.15909094,17.5 L10.3409091,17.5 L10.3409091,14.9052272 C10.9231818,14.7548864 11.4720454,14.5257954 11.9779546,14.2275 L13.8122727,16.0618182 L16.0618182,13.8122727 L14.2275,11.9779546 C14.5257954,11.4728409 14.7548864,10.9231818 14.9052272,10.3409091 L17.5,10.3409091 Z M8.75,11.1363636 C7.43193181,11.1363636 6.36363637,10.0680682 6.36363637,8.75 C6.36363637,7.43193181 7.43193181,6.36363637 8.75,6.36363637 C10.0680682,6.36363637 11.1363636,7.43193181 11.1363636,8.75 C11.1363636,10.0680682 10.0680682,11.1363636 8.75,11.1363636 Z",
  id: "Shape"
}))));

var SvgSystem = function SvgSystem(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "40px",
    viewBox: "0 0 30 40",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSystem, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/system.8786b75d.svg";
export { ForwardRef as ReactComponent };